<template>
  <div class="couponModal" v-if="showPopWindowStatus && couponBg">
    <myMask @click.stop="closeModal"></myMask>
    <div class="couponModal-win" :class="[couponModalWinBg]" :style="{'background': `url(${couponBg})`}" @click="goActivty()">
    <div @click.stop="closeModal">
      <i class="icon-close"></i>
    </div>
    </div>
  </div>
</template>

<script>
import {
    mapMutations,
    mapState,
    mapActions,
    mapGetters
} from 'vuex';
import myMask from "../common/mask.vue";
import APIS from '@/apis';
export default {
  name: "",
  components: {
    myMask
  },
  data() {
    return {};
  },
  computed:{
    ...mapState([
      'showPopWindowStatus',
      'vipPopWindow',
      'adsense',
    ]),
    couponModalWinBg(){
      return `couponModal-win_bg`
    },
    adPopupConfig() {
      let r = {}
      r = this.adsense.find(element => element['adsenseType'] == 1)
      // console.log('--- 获取到的弹窗数据 ---', r)
      return r
    },
    couponBg () {
      if (this.isHideChannel) return ''
      let config = this.adPopupConfig
      if (!config) {
        return
      }
      // console.log('--- 弹窗背景 内部渠道 ---', this.CHANNEL_INTERNALCHANNEL)
      let isInternal = config.channelScope.includes('1') && this.CHANNEL_INTERNALCHANNEL
      let isExternal = config.channelScope.includes('2') && !this.CHANNEL_INTERNALCHANNEL
      let isNotLogin = config.advertisingChannelScope && config.advertisingChannelScope.includes('1') && this.CHANNEL_NOT_LOGIN
      if (isInternal || isExternal || isNotLogin) {
        const now = new Date()
        if (config && (now > new Date(config.startTime.replace(/-/g, "/"))) && (now < new Date(config.endTime.replace(/-/g, "/")))) {
          // console.log('--- 弹窗在开始和结束时间内 ---',)
          return config.image
        } else {
          return ''
        }
      } else {
        return ''
      }

    }
  },
  mounted() {
    const that = this;
  },
  methods: {
    ...mapMutations(['setShowPopWindowStatus']),
    closeModal() {
      this.setShowPopWindowStatus(false)
      this.$emit("closeMoadl");
      if (this.$route.name == 'showIndex') {
        localStorage.setItem('dialogStore',`oneDayfristdialogStore${new Date().getDate()}`)
      }
    },
    initScroll() {},
    preventMove() {
      event.preventDefault();
    },
    goActivty(){
      this.setShowPopWindowStatus(false)
      // console.log('--- 跳转之前的路由信息 ---', this.$route)
      if (this.$route.name == 'showIndex') {
        localStorage.setItem('dialogStore', `oneDayfristdialogStore${new Date().getDate()}`)
      }
      let type = this.$route.name
      this.goIntoDialog(type, this.adPopupConfig)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/function";
@import "../../scss/components";
.couponModal {
  pointer-events: auto;
  position: relative;
  .icon-close {
    position: absolute;
    display: block;
    bottom: topx(-80rem);
    left: 50%;
    margin-left: topx(-24rem);
    width: topx(48rem);
    height: topx(48rem);
    background: url("../../assets/btn_close.png") center no-repeat;
    background-size: topx(48rem);
    z-index: 11;
  }
  .couponModal-win_bg{
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
  }
  &-win {
    position: fixed;
    top: topx(100rem);
    left: 50%;
    transform: translate(-50%, 0%);
    z-index: 11;
    width: topx(500rem);
    height: topx(800rem);
    // min-height: topx(887rem);
    // background: #FFFFFF;
    border-radius: topx(26rem);

    &.is-internal {
      width: topx(600rem);
    }

    &.is-internal-new {
      height: topx(880rem);
      width: topx(500rem);
    }

    .modal-container {
      position: absolute;
      top: topx(150rem);
      left: 0;
      right: 0;
      bottom: topx(188rem);
      overflow: hidden;
      pointer-events: auto;
    }
  }
  .btn {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0%);
    bottom: topx(50rem);
    text-align: center;
    @include btn(400rem, 80rem, 32rem);
  }
  .couponTips-cont {
    padding: topx(30rem);
    .couponTips-title {
      font-size: topx(38rem);
      color: #333333;
      line-height: topx(38rem);
      text-align: center;
      font-weight: bold;
      margin-bottom: topx(60rem);
    }
    .couponTips-tis {
      margin-top: topx(10rem);
      font-size: topx(26rem);
      color: #939799;
      line-height: topx(39rem);
      span {
        font-size: topx(26rem);
        color: #ffae00;
      }
    }
    .couponTips-box{
      margin: 0 topx(30rem);
      display: flex;
      justify-content: space-between;
    }
    .couponTips-box-left-title{
      width: topx(110rem);
      height: topx(44rem);
      line-height: topx(44rem);
      text-align: center;
      background-image: linear-gradient(-180deg, #FFE636 0%, #FFD63B 100%);
      border-radius: topx(20rem);
      font-size: topx(28rem);
      color: #613E1F;
      margin-top: topx(24rem);
    }
    .couponTips-box-left-text{
      font-size: topx(32rem);
      color: #666666;
      line-height: topx(46rem);
      margin-top: topx(17rem);
    }
    .couponTips-box-rigth{
      width: topx(296rem);
      height: topx(376rem);
      background: url('../../assets/member/couponTips-boxshare.png') no-repeat center;
      background-size: 100% 100%;
    }
  }
  .couponTips-cont-btn{
    width: topx(300rem);
    height: topx(300rem);
    margin: topx(500rem) auto 0;

  }
}
</style>



// WEBPACK FOOTER //
// src/components/member/couponDialog.vue